import Vue, { CreateElement } from '@src/vue'

import { Component } from 'vue-property-decorator'

import { Dialog } from '@src/components/dialog/dialog'
import { Icon } from '@src/elements/icon/icon'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { Link } from '@src/elements/link/link'
import { Spacer } from '@src/elements/spacer/spacer'
import { Body1 } from '@src/elements/typography/typography'
import { LanguageSwitch } from '@src/components/language-switch/language-switch'
import { MemberService } from '@src/service/member'
import SessionManager from '@src/lib/session_manager'

import './email-update.sass'

@Component
export class EmailUpdate extends Vue {

  token: string = ''

  success: boolean = false
  requestInProgress: boolean = false

  service: MemberService = new MemberService()

  beforeMount () {
    this.token = this.$route.params.token
  }

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('RESET')}`
  }

  mounted () {
    SessionManager.Instance.setTrainer(this.$route.path.includes('trainer'))

    return this.confirmationRequest()
  }

  confirmationRequest () {
    this.requestInProgress = true
    return this.service.confirmEmailUpdate(this.token)
      .then(() => this.success = true)
      // an expired or used link, the page shows the error
      .catch(() => this.success = false)
      .finally(() => this.requestInProgress = false)
  }

  render (h: CreateElement) {
    return <div class='update-email-page'>
      <Dialog>
        {this.requestInProgress ?
          <div>
            <Spacer />
            <Spacer />
            <Loader color='white' />
            <Spacer />
            <Spacer />
          </div> :
          <div>
            {this.success ?
              <Icon name='brand/high-five' class='success-icon' />
              : <Icon name='brand/face-angry' class='error-icon' />
            }
            <Spacer />
            {this.success ?
              <Body1 align='center'>{this.$t('PAGE.UPDATE_EMAIL.SUCCESS')}</Body1>
              : <Body1 align='center'>{this.$t('PAGE.UPDATE_EMAIL.ERROR')}</Body1>
            }
            <Spacer />
            <Spacer />
          </div>
        }
        <div>
          <Link ref='login-link' class='login-link' align={'center'} label={this.$t('PAGE.UPDATE_EMAIL.BACK_TO_LOGIN')} click={() => this.$router.push('/')} />
        </div>
        <Spacer />
        <LanguageSwitch />
      </Dialog>
    </div>
  }
}
